import UsersTeam from './UsersTeam';

export default UsersTeam;
